import type { LovOutilFpeDTO, OutilFpeDTO } from '@/features/api/extranet/dto/Demande/OUTILFPE'
import type { FraisDTO } from '@/features/api/extranet/dto/Demande/shared'
import { EndPointsTtDemandeOUTILFPE } from '@/features/services'
import { buildDemandeService } from '../buildDemandeService'

export default buildDemandeService<'MODEL_OUTIL_FPE', LovOutilFpeDTO>({
  location: EndPointsTtDemandeOUTILFPE.location,
  normaliserData: normaliserData,
})

function normaliserData(data: OutilFpeDTO) {
  data.fichiers ??= []

  data.employeur ??= {} as any
  data.employeur!.contact ??= {} as any
  data.employeur!.etablissement ??= {} as any
  data.employeur!.etablissement!.adresse ??= {} as any

  data.prestation ??= {} as any
  data.prestation!.fraisAnnexes ??= []
  if ((data.prestation!.fraisAnnexes?.length ?? 0) === 0) {
    data.prestation!.fraisAnnexes?.push({
      mode: 'Annexe',
      nature: 'AchatMateriel',
      baseCalcul: 'Quantite',
      montant: null,
      quantite: null,
    } as FraisDTO)
  }
  return data
}
